import axios from 'axios';

export const addBackground = (host, shopId) => {
  return dispatch => {

    var url = "https://" + host + "/v1/backgrounds";
    axios.post(url, {
      shopId
    })
    .then(res => {
      if(res.data.success = true) {
        dispatch(updateBackgroundsSuccess(res.data.backgrounds));
      } else {
        console.log("Server error");
      }
    })
    .catch(err => {
      console.log(err);
    })
  }
};

export const onBackgroundChange = (index, key, value) => {
  return {
    type: "ON_BACKGROUND_CHANGE",
    index: index,
    key: key,
    value: value
  }
};

export const updateBackground = (host, background) => {
  return dispatch => {
    var url = "https://" + host + "/v1/backgrounds/" + background.id;
    axios.put(url, {
      background: background
    })
    .then(res => {
      if(res.data.success = true) {
        dispatch(updateBackgroundsSuccess(res.data.backgrounds));
      } else {
        console.log("Server error");
      }
    })
    .catch(err => {
      //dispatch(addBackgroundError());
      console.log(err);
    })
  }
};

export const deleteBackground = (host, background) => {
  return dispatch => {
    var url = "https://" + host + "/v1/backgrounds/" + background.id;
    axios.delete(url)
    .then(res => {
      if(res.data.success = true) {
        dispatch(updateBackgroundsSuccess(res.data.backgrounds));
      } else {
        console.log("Server error");
      }
    })
    .catch(err => {
      //dispatch(addBackgroundError());
      console.log(err);
    })
  }
}

export const updateBackgroundsSuccess = backgrounds => ({
  type: "UPDATE_BACKGROUNDS_SUCCESS",
  backgrounds: backgrounds
})

